// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import { getTheme } from 'settings/theme/index';
import { Link } from 'react-router-dom';

const {
  noodera: { fontTypes, spacing },
  palette: { neutral },
} = getTheme();

export const StyledTable: StatelessFunctionalComponent<any> = styled(Table)`
  &&& {
    & th,
    & td {
      ${fontTypes.font4};
      padding: ${spacing.x7} ${spacing.x8};
    }

    & tr > th:first-of-type {
      padding-left: 0;
    }
  }
`;

export const StyledTableHead: StatelessFunctionalComponent<any> = styled(TableHead)`
  &&& {
    & > tr > th {
      ${fontTypes.font4Medium};
    }
  }
`;

export const BoldTableCell: StatelessFunctionalComponent<any> = styled(TableCell)`
  &&&& {
    ${fontTypes.font4Medium};
  }
`;

export const BoldTableCellHeading: StatelessFunctionalComponent<any> = styled(TableCell)`
  &&&& {
    ${fontTypes.font5Medium};
    color: ${neutral.seventy};
  }
`;

export const CellTextLink: StatelessFunctionalComponent<any> = styled(Link)`
  ${(props) => props.theme.underlineLink}
  ${fontTypes.font4Medium}
  color: ${(props) => props.theme.palette.primary.hundred};
`;
